import React from "react";
import { useApp } from "../../../state/Context";
import Card from "../ui/Card";

const ROADMAP = [
  {
    date: "March 2026",
    tag: "Version 1 (released)",
    title: "Bachelor's degrees release",
    description:
      "Initial release with undergraduate classification flows (BA/BSc/BEng) and core university catalog coverage.",
  },
  {
    date: "April 2026",
    tag: "Version 2",
    title: "Master's degrees release",
    description:
      "Postgraduate taught support (MSc/MA) with refined weighting and module structures.",
  },
  {
    date: "June 2026",
    tag: "Version 3",
    title: "Integrated Master's degrees release",
    description:
      "Integrated Master’s pathways (MEng/MSci) with combined year weighting models.",
  },
  {
    date: "July 2026",
    tag: "Version 4",
    title: "PhD degrees release",
    description:
      "Doctoral / research-oriented pathways and milestone tracking utilities.",
  },
];

function TimelineItem({ item, isLast }) {
  return (
    <div className="relative pl-10">
      {/* vertical line */}
      {!isLast && (
        <div className="absolute left-[18px] top-8 h-[calc(100%-12px)] w-px bg-neutral-200 dark:bg-neutral-800" />
      )}

      {/* node */}
      <div className="absolute left-3 top-2 h-3 w-3 rounded-full bg-neutral-900 ring-4 ring-neutral-100 dark:bg-neutral-100 dark:ring-neutral-900" />

      {/* card */}
      <div className="rounded-2xl border border-neutral-200 bg-white p-4 shadow-sm dark:border-neutral-800 dark:bg-neutral-950">
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-xs font-semibold text-neutral-500 dark:text-neutral-400">
            {item.date}
          </span>
          <span className="text-neutral-300 dark:text-neutral-700">→</span>
          <span className="rounded-md bg-neutral-100 px-2 py-0.5 text-xs font-semibold text-neutral-700 dark:bg-neutral-900 dark:text-neutral-200">
            {item.tag}
          </span>
        </div>

        <h3 className="mt-2 text-base font-semibold text-neutral-900 dark:text-neutral-50">
          {item.title}
        </h3>

        <p className="mt-1 text-sm text-neutral-600 dark:text-neutral-400">
          {item.description}
        </p>
      </div>
    </div>
  );
}

export default function Timeline() {
  const { setSelection } = useApp();

  return (
    <div className="mx-auto max-w-4xl space-y-6">
      {/* Back */}
      <div className="flex items-center">
        <button
          type="button"
          onClick={() => setSelection((prev) => ({ ...prev, step: "select" }))}
          className="
            rounded-xl border border-neutral-200 bg-white px-3 py-2
            text-sm font-semibold text-neutral-800
            hover:bg-neutral-100
            dark:border-neutral-800 dark:bg-neutral-950
            dark:text-neutral-100 dark:hover:bg-neutral-900
          "
        >
          ← Back to selection
        </button>
      </div>

      <Card className="p-6">
        {/* Header */}
        <div className="space-y-1">
          <h1 className="text-2xl font-semibold tracking-tight">Product roadmap</h1>
          <p className="text-sm text-neutral-600 dark:text-neutral-400">
            What’s shipping next for Degree Classify UK.
          </p>
        </div>

        {/* Timeline */}
        <div className="mt-6 space-y-5">
          {ROADMAP.map((item, idx) => (
            <TimelineItem
              key={`${item.date}-${item.title}`}
              item={item}
              isLast={idx === ROADMAP.length - 1}
            />
          ))}
        </div>

        {/* Footer note */}
        <div className="mt-6 rounded-xl border border-neutral-200 bg-neutral-50 px-4 py-3 text-xs text-neutral-600 dark:border-neutral-800 dark:bg-neutral-900 dark:text-neutral-400">
          Dates are targets and may shift as additional universities and edge cases are validated.
        </div>
      </Card>
    </div>
  );
}